module.exports = __webpack_public_path__ + "static/media/4.18_preview.709754b5.png";